import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';
import { DateFormatter } from '../../utils/DateFormatter';

const ClassWiseReport = ({classReportData,  hasMultipleAssignment, openStudentReport, selectedClassId, handleSort,
  renderSortIcons, ferpaEnabled, isSingleStudent, hideClassColumn, assignmentCanDrillDown, drillDownOnClick})=>{

  return(
    <>
      <table className='table reportTable px-slim'>
        {classReportData ? (
          <>
            <thead className='thead-light align-middle'>
              <tr >
                {hasMultipleAssignment && <th scope="col" className='cursor-pointer fw-medium tot-name' onClick={() => {handleSort?handleSort('assignmentName'):null;}}>
                  <span className='d-flex justify-content-center'>
                    <span className='align-items-center d-flex gap-2 justify-content-between'> <span className={`${handleSort?'pl-15':''}`}>Assignment Name</span> {renderSortIcons('assignmentName')} </span>
                  </span>
                </th>}
                {!isSingleStudent && <>
                  <th scope="col" className='cursor-pointer fw-medium' onClick={() => {handleSort?handleSort('lName'):null;}}>
                    <span className='d-flex justify-content-center'>
                      <span className='align-items-center d-flex gap-2 justify-content-between'> <span className={`${handleSort?'pl-15':''}`}>Last Name</span> {renderSortIcons('lName')} </span>
                    </span>
                  </th>
                  <th scope="col" className='cursor-pointer fw-medium' onClick={() => {handleSort?handleSort('fName'):null;}}>
                    <span className='d-flex justify-content-center'>
                      <span className='align-items-center d-flex gap-2 justify-content-between'><span className={`${handleSort?'pl-15':''}`}>First Name</span> {renderSortIcons('fName')}</span>
                    </span>
                  </th>
                  <th scope="col" className={`cursor-pointer fw-medium ${selectedClassId > 0 || hideClassColumn ? 'd-none' : ''}`} onClick={() => {handleSort?handleSort('classes'):null;}}>
                    <span className='d-flex justify-content-center'>
                      <span className='align-items-center d-flex gap-2 justify-content-between'><span className={`${handleSort?'pl-15':''}`}>Class</span> {renderSortIcons('classes')}</span>
                    </span>
                  </th>
                </> }
                <th scope="col"  className='cursor-pointer fw-medium' onClick={() => {handleSort?handleSort('startedOn'):null;}}>
                  <span className='d-flex justify-content-center'>
                    <span className='align-items-center d-flex gap-2 justify-content-between'><span className={`${handleSort?'pl-15':''}`}>Assignment Started On</span> {renderSortIcons('startedOn')}</span>
                  </span>
                </th>
                <th scope="col"  className='cursor-pointer fw-medium' onClick={() => {handleSort?handleSort('completedOn'):null;}}>
                  <span className='d-flex justify-content-center'>
                    <span className='align-items-center d-flex gap-2 justify-content-between'><span className={`${handleSort?'pl-15':''}`}>Assignment Completed On</span> {renderSortIcons('completedOn')}</span>
                  </span>
                </th>
                <th scope="col"  className='cursor-pointer fw-medium' onClick={() => {handleSort?handleSort('totalTime'):null;}}>
                  <span className='d-flex justify-content-center'>
                    <span className='align-items-center d-flex gap-2 justify-content-between'><span className={`${handleSort?'pl-15':''}`}>Total Time On Assignment <span className='fs-7 fw-normal'>(HH:MM:SS)</span></span>{renderSortIcons('totalTime')}</span>
                  </span>
                </th>
              </tr>
            </thead>  
            <tbody>
              {classReportData?.map((item) => (
                <tr key={`${item.studentId}-record`}>
                  {hasMultipleAssignment && assignmentCanDrillDown && <td className='cursor-pointer text-center tot-name'
                    onClick={() =>
                      isSingleStudent? drillDownOnClick(item.assignmentId, item.assignmentName, item.studentId, item.lName + ' ' + item.fName, false,true) :
                        drillDownOnClick(selectedClassId,item.assignmentId,true)
                    }>
                    <span className='fw-600 border-b-2 clickable-link'> {item.assignmentName}</span></td>
                  }
                  {hasMultipleAssignment && !assignmentCanDrillDown && 
                    <td className='text-center tot-name'>{item.assignmentName}</td>}
                  {!isSingleStudent && <>
                    <td className='cursor-pointer text-center' onClick={() => openStudentReport(item.assignmentId, item.assignmentName, item.studentId, item.lName + ' ' + item.fName, item.isRetake)}><span className='fw-600 border-b-2 clickable-link'>{ferpaEnabled ? item.lName : <i>Last name hidden</i>}</span></td>
                    <td className='cursor-pointer text-center' onClick={() => openStudentReport(item.assignmentId, item.assignmentName, item.studentId, item.lName + ' ' + item.fName, item.isRetake)}><span className='fw-600 border-b-2 clickable-link'>{ferpaEnabled ? item.fName : <i>First name hidden</i>}</span></td>
                    <td className={`text-center ${selectedClassId > 0 || hideClassColumn ? 'd-none' : ''}`}>{item.classes}</td>
                  </>}
                  <td className='text-center'>{DateFormatter.toLongDateTime(item.startedOn)}</td>
                  <td className={`${item.completedOn?'text-center':'text-center'}`}>{item.completedOn ? DateFormatter.toLongDateTime(item.completedOn) : 'not completed'}</td>
                  <td className='info-text text-center'>{item.totalTime}</td>
                </tr>
              ))}
              {classReportData?.length ==0 &&<tr>
                <td colSpan={6} className='text-center text-danger'>You have no assignments or self study sessions that were taken in time on task mode!</td></tr>}
            </tbody>
          </>
        ) : (
          <><tr className="score-table-head">
            <th> <Skeleton /></th>
            <th> <Skeleton /></th>
            <th> <Skeleton /></th>
            <th> <Skeleton /></th>
            <th> <Skeleton /></th>
            <th> <Skeleton /></th>
          </tr>
          <tr className="tabel-body">
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>
          <tr className="tabel-body">
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>
          <tr className="tabel-body">
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
            <td><Skeleton /></td>
          </tr>
          </>
        )}
      </table>
    </>
  );
};

ClassWiseReport.propTypes = {
  classReportData: PropTypes.object,
  hasMultipleAssignment: PropTypes.bool,
  openStudentReport: PropTypes.func,
  selectedClassId: PropTypes.number,
  handleSort: PropTypes.func,
  renderSortIcons: PropTypes.func,
  ferpaEnabled: PropTypes.bool,
  isSingleStudent: PropTypes.bool,
  hideClassColumn : PropTypes.bool,
  assignmentCanDrillDown : PropTypes.bool,
  drillDownOnClick: PropTypes.func
};
  
export default ClassWiseReport;